export default {
  path: '/sims/sim-search',
  name: 'SimSearch',
  component: () => import(/* webpackChunkName: "base" */ '../views/SimSearchView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
